/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dropdown } from "@carbon/react";
import React from "react";
import TextField from "../components/inputs/TextField";
import { FORM_VALIDATION_TRANSLATIONS } from "../translations/util";

interface IProps {
  onChange?: any;
  label: string;
  placeholder: string[] | undefined;
  disabled?: boolean;
  setCurrentItem?: any;
  currentItem?: any;
  invalid?: boolean;
  invalidText?: string;
  tooltipText?: string;
  required?: boolean;
  items: string[] | undefined;
  dropdownDisabled?: boolean;
  value?: string;
  handleResetData?: () => void;
}

const MappedValueDropdown = ({
  onChange,
  label,
  placeholder,
  disabled = false,
  invalid = false,
  invalidText,
  tooltipText,
  required,
  items,
  setCurrentItem,
  currentItem,
  dropdownDisabled = true,
  value,
  handleResetData,
}: IProps) => {
  return (
    <div className="hexdec-block" data-cy="hexdec-block">
      <div className="input-wrapper searchable-dropdown">
        <Dropdown
          className="input-dropdown"
          data-cy="mapped-input-dropdown"
          items={items}
          disabled={dropdownDisabled}
          selectedItem={currentItem}
          onChange={({ selectedItem }: { selectedItem: string }) => {
            if (handleResetData) {
              handleResetData();
            }
            setCurrentItem(selectedItem);
          }}
        />
        <div className="input-field">
          <TextField
            labelText={label}
            onChange={onChange}
            value={value}
            placeholder={
              items !== undefined &&
              placeholder !== undefined &&
              currentItem !== ""
                ? placeholder[items?.indexOf(currentItem)]
                : "MAPPED-VALUES"
            }
            required={required}
            tooltipText={tooltipText}
            invalid={invalid}
            invalidText={
              invalidText || FORM_VALIDATION_TRANSLATIONS.required(currentItem)
            }
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default MappedValueDropdown;
